import { Component, ElementRef, Inject, Input } from '@angular/core';
import { EventBus, EventBusBase, RoutingService } from '@skylab-angular-shared/core';
import { UIEvents } from '../../utils/ui-events';
import { MenuComponentBase } from '../menu-base.component';
import { MenuItem } from '../menu.model';
import { MenuItemSubComponent } from '../menu-item-sub/menu-item-sub.component';
import { MenuItemComponent } from '../menu-item/menu-item.component';

@Component({
    selector: 'skl-menu-sub',
    templateUrl: './menu-sub.component.html',
    imports: [MenuItemSubComponent, MenuItemComponent]
})
export class MenuSubComponent extends MenuComponentBase {
    @Input() public parentMenuId!: string;
    @Input() public closeParent!: ($event?: Event) => void;

    private menuClosedHandler!: string;

    public constructor(
        elRef: ElementRef,
        routingService: RoutingService,
        @Inject(EventBus) eventBus: EventBusBase
    ) {
        super(elRef, eventBus, routingService);
    }

    public override ngOnInit(): void {
        this.menuClosedHandler = this.eventBus.observe(UIEvents.MenuClosed, (menuId: string) => {
            if (menuId === this.parentMenuId) {
                this.close();
            }
        });
        //this.bindEvents();
    }

    public override ngOnDestroy(): void {
        this.eventBus.deleteObserver(this.menuClosedHandler);
        //this.unbindEvents();
    }

    public override onItemSelect(item: MenuItem): void {
        if (item.isDisabled(this.context)) return;
        item.click?.(this.context);
        if (!item.submenu) {
            this.close();
            this.closeParent();
        }
    }
}
